import { Component } from 'react';
import { Flow } from 'flow-react';
import { observer } from "mobx-react"
import { Container, Col, Row} from 'react-bootstrap';
import  france_tv_on  from 'assets/pics/france_tv_pro_blanc.png';
import './Mentionslegal.css'; 


const Mentionslegal = observer(
  class Mentionslegal extends Component {
	
		state = {baba:'dudu'};
		

			
    render() {
			return  (
				
				<div className="menlegcont">
				<div className="menlegheading">mentions légales</div>
				<ol>
					<li>Editeur : France Télévisions</li>
					<li>Siège social : 7, Esplanade Henri de France 75015 PARIS</li>
					<li>Société Anonyme au capital de 347 540 000 euros</li>
					<li>RCS de Paris : 432 766 947</li>
					<li>Direction de la Publication : Delphine Ernotte Cunci</li>
					<li>Tel : (+33) 08 90 71 02 02 (0.15 €/min)</li>
					<li>Hébergeur : Anexia</li>
					<li>Siège social: Feldkirchner Straße 140 - 9020 Klagenfurt - Austria</li>
					<li>Numéro de téléphone : +43 50 556</li>
				</ol>
				</div>
			)
    }
		
		
		
  }
)


export default Flow.injectFlow(Mentionslegal);